import { TaskType } from 'features/controlCenter/types';

export const TASK_TYPES = {
  SESSION_PREP: 'coaching_session_prep',
  SESSION: 'coaching_session',
  SESSION_RECAP: 'coaching_session_recap',
  SESSION_NOTE: 'coaching_session_notes',
  UNREAD_CHAT: 'unread_chat',
  UNREAD_JOURNAL: 'unread_journal',
  CUSTOM: 'custom',
} as const;

export const GROUPED_JOURNAL_TASKS_TYPE = 'grouped_journal_tasks';

export const TASK_STATUSES = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  POSTPONED: 'postponed',
  UPCOMING: 'upcoming',
  ARCHIVED: 'archived',
  OUTSTANDING: 'outstanding',
} as const;

export const TASK_TITLES_BY_TYPE = {
  [TASK_TYPES.SESSION_RECAP]: 'Send session recap to',
  [TASK_TYPES.SESSION_PREP]: 'Prep for coaching session with',
  [TASK_TYPES.SESSION_NOTE]: 'Create session note for',
  [TASK_TYPES.SESSION]: 'Coaching session with',
  [TASK_TYPES.UNREAD_CHAT]: 'Unread chat message from',
  [TASK_TYPES.UNREAD_JOURNAL]: 'Note from',
  [TASK_TYPES.CUSTOM]: 'Custom task',
} as const;

export const TASK_NAMES_BY_TASK_TYPE_MAP = {
  [TASK_TYPES.SESSION_RECAP]: 'Send recap',
  [TASK_TYPES.SESSION_PREP]: 'Preparation for session',
  [TASK_TYPES.SESSION_NOTE]: 'Session note',
  [TASK_TYPES.SESSION]: 'Session',
  [TASK_TYPES.UNREAD_JOURNAL]: 'Unread journal note',
  [TASK_TYPES.UNREAD_CHAT]: 'Unread message',
  [TASK_TYPES.CUSTOM]: 'Custom',
} as const;

export const SESSION_RECAP_TAB_INDEX = 3;

export const TAB_INDEX_BY_TASK_TYPE_MAP: Partial<Record<TaskType, number>> = {
  [TASK_TYPES.SESSION_RECAP]: SESSION_RECAP_TAB_INDEX,
  [TASK_TYPES.SESSION_PREP]: 1,
  [TASK_TYPES.SESSION_NOTE]: 0,
};

export const DEFAULT_TASK_PRIORITY = 0;
export const TASK_TYPES_PRIORITIES_MAP = {
  [TASK_TYPES.UNREAD_CHAT]: 2,
  [TASK_TYPES.UNREAD_JOURNAL]: 1,
};

export const TASK_ACTIONS = {
  COMPLETE: 'complete',
  UNDO: 'undo',
} as const;

export const DATE_QUERY_PARAM = 'date';
